import { ApiError, beablooApi } from '../../utils';

const setIntegrations = () => {
  return async (dispatch, getState) => {
    const { general } = getState();

    const response = await beablooApi({
      method: 'GET',
      route: `/developments/${general.currentDevelopment.id}/integrations`,
    })
      .then((r) => r.data)
      .catch((e) => {
        throw new ApiError('failed to get integrations', []);
      });

    dispatch({
      type: 'SET_INTEGRATIONS',
      data: response,
    });
  };
};

const updateIntegrations = (data) => {
  return {
    type: 'UPDATE_INTEGRATIONS',
    data: data,
  };
};

export { setIntegrations, updateIntegrations };
 